import React from "react";
import {
  Container,
  Wrapper,
  activeStyle,
  notActive,
  Icon as Icons,
  Box,
} from "./style";
import { Dashboard as data } from "../../../utils/dashboard";
import { NavLink } from "react-router-dom";
import { useLocation, Outlet } from "react-router-dom";
import DashboardComponent from "../Dashboardd";
export const Sidebar = () => {
  const location = useLocation();
  return (
    <Wrapper>
      <Container>
        {data.map(({ title, id, pathname, Icon }) => (
          <NavLink
            key={id}
            to={pathname}
            style={({ isActive }) => (isActive ? activeStyle : notActive)}
          >
            <Box active={location.pathname === pathname}>
              <Icons active={location.pathname === pathname}>
                <Icon className="hovarble" />
              </Icons>
              {title}
            </Box>
          </NavLink>
        ))}
      </Container>
      {location?.pathname === "/sell/dashboard" ? (
        <DashboardComponent />
      ) : (
        <Outlet />
      )}
    </Wrapper>
  );
};
export default Sidebar;
